module.exports = __webpack_public_path__ + "static/media/flashWarning.7b3d7a02.svg";